module.exports = __webpack_public_path__ + "static/media/icon-deposit.92e77a46.png";